module.exports = __webpack_public_path__ + "static/assets/208f28114c3654417aae9f71542d1670.png";